import React, { Component } from 'react';

class AboutContainer extends Component {
  render() {
    return (
      <section id="section-about">
        <div className="container">
            <div className="jumbotron">
                <h1>ABOUT</h1>
                <p>I’m a
                    <em>passionate</em> and
                    <em>pragmatic software engineer</em> with
                    <em>12 years</em> of experience.
                </p>
                <p>
                    </p><p>
                        I can assist in all stages of software development lifecycle and deliver working software with
                        <em>clean architecture</em>,
                        <em>clean code</em>, and
                        <em>automated tests.</em>
                    </p>
                <p></p>
            </div>
        </div>
      </section>
    );
  }
}

export default AboutContainer;



// WEBPACK FOOTER //
// ./src/containers/about.container.jsx